// extracted by mini-css-extract-plugin
module.exports = {"root":"ChatSeqViewPage_root__1PTpN","title":"ChatSeqViewPage_title__1k7LQ","chatSequenceView":"ChatSeqViewPage_chatSequenceView__3YTat"};